import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import templateFileDataService from "services/templateFile";

// Async thunk for uploading files
export const uploadTemplateFileAsync = createAsyncThunk(
  "templateFile/upload",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await templateFileDataService.upload(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Convert template file to a pdf
export const convertTemplateToPdfAsync = createAsyncThunk(
  "templateFile/convertToPdf",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await templateFileDataService.convertToPdf(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async thunk for uploading files
export const updateTemplateFileAsync = createAsyncThunk(
  "templateFile/updateTemplateFileAsync",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await templateFileDataService.update(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  uploadTemplateFileStatus: {
    status: "idle",
    error: null,
    data: null,
  },
  updateTemplateFileStatus: {
    status: "idle",
    error: null,
    data: null,
  },
};

const uploadTemplateFileSlice = createSlice({
  name: "templateFile",
  initialState,
  reducers: {
    resetUploadFileStatus: (state) => {
      state.uploadTemplateFileStatus = initialState.uploadTemplateFileStatus;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadTemplateFileAsync.pending, (state) => {
        state.uploadTemplateFileStatus.status = "loading";
        state.uploadTemplateFileStatus.error = null;
        state.uploadTemplateFileStatus.data = null;
      })
      .addCase(uploadTemplateFileAsync.fulfilled, (state, action) => {
        state.uploadTemplateFileStatus.status = "succeeded";
        state.uploadTemplateFileStatus.data = action.payload;
      })
      .addCase(uploadTemplateFileAsync.rejected, (state, action) => {
        state.uploadTemplateFileStatus.status = "failed";
        state.uploadTemplateFileStatus.error = action?.payload?.messageText;
      })
      .addCase(updateTemplateFileAsync.pending, (state) => {
        state.updateTemplateFileStatus.status = "loading";
        state.updateTemplateFileStatus.error = null;
        state.updateTemplateFileStatus.data = null;
      })
      .addCase(updateTemplateFileAsync.fulfilled, (state, action) => {
        state.updateTemplateFileStatus.status = "succeeded";
        state.updateTemplateFileStatus.data = action.payload;
      })
      .addCase(updateTemplateFileAsync.rejected, (state, action) => {
        state.updateTemplateFileStatus.status = "failed";
        state.updateTemplateFileStatus.error = action?.payload?.messageText;
      });
  },
});

export const { resetUploadFileStatus } = uploadTemplateFileSlice.actions;

export default uploadTemplateFileSlice.reducer;
